import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

/**
 * Service to abstract window.location for better testability
 */
@Injectable({
  providedIn: 'root'
})
export class LocationService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  /**
   * Get the current pathname
   * Returns empty string if not in browser environment
   */
  getPathname(): string {
    if (isPlatformBrowser(this.platformId)) {
      return window.location.pathname;
    }
    return '';
  }

  /**
   * Get the full URL
   * Returns empty string if not in browser environment
   */
  getHref(): string {
    if (isPlatformBrowser(this.platformId)) {
      return window.location.href;
    }
    return '';
  }

  /**
   * Navigate to a URL
   * Does nothing if not in browser environment
   */
  navigate(url: string): void {
    if (isPlatformBrowser(this.platformId)) {
      window.location.href = url;
    }
  }
}
